<template>
  <div class="com-dashboard" :style="{ background: properties.bgColor, border: properties.border, borderRadius: properties.borderRadius, height: (contenitoreHeight)+ 'px'}" v-loading="loading">
    <div v-if="properties.compressa" class="compressa">
      <div v-if="properties.icona === ''" class="tipologia">
        <span>{{properties.title.toUpperCase()}}</span>
      </div>
      <div v-else class="tipologia-icon">
        <icon :name="properties.icona" scale="2.9" :style="{ color: properties.iconColor }"></icon>
        <div class="titolo">
          <span class="riga1 truncate">{{properties.title.toUpperCase()}}</span>
          <span class="riga2">{{ $t('messages.comunicazioni', {num: messaggi.length}) }}</span>
        </div>
      </div>
      <div class="comunicazione" v-for="(messaggio, index) in messaggi" :key="index" :class="index === messaggi.length -1 ? 'last' : ''">
        <div class="com-titolo">
          <span class="titolo truncate">{{messaggio.titolo}}</span>
          <span class="data">
          {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
          </span>
        </div>
        <div class="com-action">
          <el-button class="WEB-button WEB-button-header" @click="openMessageModal(messaggio)">{{ $t('messages.leggi') }}</el-button>
        </div>
      </div>
    </div>
    <div v-else class="normale">
      <div v-if="properties.icona === ''" class="tipologia">
        <span>{{properties.title.toUpperCase()}}</span>
      </div>
      <div v-else class="tipologia-icon">
        <icon :name="properties.icona" scale="2.9" :style="{ color: properties.iconColor }"></icon>
        <div class="titolo">
          <span class="riga1 truncate">{{properties.title.toUpperCase()}}</span>
          <span class="riga2">{{ $t('messages.comunicazioni', {num: '10'}) }}</span>
        </div>
      </div>
      <div class="comunicazione" v-for="(messaggio, index) in messaggi" :key="index" :class="index === messaggi.length -1 ? 'last' : ''">
        <div class="com-titolo">
          <span class="titolo truncate">{{messaggio.titolo}}</span>
          <el-button class="WEB-button WEB-button-header" @click="openMessageModal(messaggio)">{{ $t('messages.leggi') }}</el-button>
        </div>
        <div class="com-testo truncate" v-html="messaggio.testo"></div>
        <div class="com-data">
          {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
        </div>
      </div>
    </div>

    <el-dialog class="modal-message" :visible.sync="showModal" @close="closeMessageModal"
               width="600px" :append-to-body="true" 
               :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('messages')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1, messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub, 'YYYY-MM-DD-HH.mm').format('DD/MM/YYYY HH:mm') }}
      </div>
      <div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
        {{ $t('messages.scade') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary" v-if="(messaggio.sePresaVis === 'Y' && messaggio.presaVis === 'N')" @click.native="setMessaggioService(messaggio, 'P', true)">
            {{ $t('messages.presaVisione').toUpperCase() }}
          </el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import mixinDownload from "../../assets/mixins/downloadDoc.js";

export default {
  name: 'Comunicazione',
  mixins: [mixinDownload],
  props: {
    properties: {
      type: Object,
      required: true,
      default: function () {
        return {
          compressa: true,
          bgColor: 'red',
          border: '1px solid #e7e7e7',
          icona: 'riv-tick',
          iconColor: 'white',
          title: 'Titolo',
          type: 'ANN',
        }
      }
    },
    contenitoreHeight: {
      type: Number
    },
    loading: {
      required: true,
      type: Boolean,
      default: false
    },
    ['messaggi']: {
      type: Array,
      required: true,
      default: []
    }
  },
  i18n: {
    messages: {
      it_IT: {
        messages: {
          comunicazioni: '{num} comunicazioni',
          noMsg: 'Nessun messaggio',
          1: 'Lunedì',
          2: 'Martedì',
          3: 'Mercoledì',
          4: 'Giovedì',
          5: 'Venerdì',
          6: 'Sabato',
          0: 'Domenica',
          leggi: 'Leggi',
          priorita: {
            label: 'Priorità',
            1: 'Alta'
          },
          elimina: 'Elimina',
          scade: 'Scade il',
          ricevuto: 'Ricevuto il',
          presaVisione: 'Presa Visione'
        }
      },
      fr_FR: {
        messages: {
          comunicazioni: '{num} communications',
          noMsg: 'Pas de message',
          1: 'Lundi',
          2: 'Mardi',
          3: 'Mercredi',
          4: 'Jeudi',
          5: 'Vendredi',
          6: 'Sabbat',
          0: 'Dimanche',
          leggi: 'Lire',
          priorita: {
            label: 'Priorité',
            1: 'Haute'
          },
          elimina: 'Éliminer',
          scade: 'Expire le',
          ricevuto: 'Reçu le',
          presaVisione: 'Presa Visione'
        }
      },
      es_ES: {
        messages: {
          comunicazioni: '{num} Comunicaciones',
          noMsg: 'Sin mensaje',
          1: 'Lunes',
          2: 'Martes',
          3: 'Miércoles',
          4: 'Jueves',
          5: 'Viernes',
          6: 'Sábado',
          0: 'Domingo',
          leggi: 'Leer',
          priorita: {
            label: 'Prioridad',
            1: 'Alto'
          },
          elimina: 'Eliminar',
          scade: 'Vence el',
          ricevuto: 'Recibido el',
          presaVisione: 'Presa Visione'
        }
      },
      de_DE: {
        messages: {
          comunicazioni: '{num} kommunikation',
          noMsg: 'Keine nachricht',
          1: 'Montag',
          2: 'Dienstag',
          3: 'Mittwoch',
          4: 'Donnerstag',
          5: 'Freitag',
          6: 'Sabbat',
          0: 'Sonntag',
          leggi: 'Lesen',
          priorita: {
            label: 'Priorität',
            1: 'Hoch'
          },
          elimina: 'Beseitigen',
          scade: 'Läuft am ab',
          ricevuto: 'Eingegangen am',
          presaVisione: 'Presa Visione'
        }
      },
      en_GB: {
        messages: {
          comunicazioni: '{num} comunicazioni',
          noMsg: 'No messages',
          1: 'Monday',
          2: 'Tuesday',
          3: 'Wednesday',
          4: 'Thursday',
          5: 'Friday',
          6: 'Saturday',
          0: 'Sunday',
          leggi: 'Read',
          priorita: {
            label: 'Priority',
            1: 'High'
          },
          elimina: 'Remove',
          scade: 'Expires',
          ricevuto: 'Received on',
          presaVisione: 'Presa Visione'
        }
      }
    }
  },
  data () {
    return {
      moment: moment,
      //messaggi: [],
      //loading: false,
      showModal: false,
      messaggio: {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      },
      numMsg: 0
    }
  },
  filters: {
  },
  mounted: function () {
    //this.loadCom()
  },
  methods: {
    loadCom: function () {
      this.$set(this, 'loading', true)
      this.$set(this, 'messaggi', [])
      this.$set(this, 'numMsg', 0)
      var obj = {
        params: {
          seBlock: 'N',
          tipo: this.properties.type,
          order: ''
        }
      }
      this.$http.get('communication/' + this.$store.state.country + '/messaggi', obj).then(response => {
        if (response.body.rc === 0) {
          this.$set(this, 'messaggi', response.body.data)
          this.$set(this, 'numMsg', response.body.data.length)
        }
        this.$set(this, 'loading', false)
      }, response => {
        this.$set(this, 'loading', false)
      })
    },
    openMessageModal: function (msg) {
      this.$set(this, 'showModal', true)
      this.$set(this, 'messaggio', msg)
      if (msg.seLetto === undefined || msg.seLetto === 'N') {
        this.setMessaggioService(msg, 'L', false)
      }
    },
    closeMessageModal: function () {
      this.$set(this, 'showModal', false)
      let msg =  {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      }
      this.$set(this, 'messaggio', msg)
    },
    setMessaggioService: function (messaggio, operazione, closeModal) {
      let data = new FormData()
      data.append('id', messaggio.id)
      data.append('op', operazione)
      this.$http.post('communication/' + this.$store.state.country + '/messaggio', data)
        .then(response => {
          if (response.body.rc === 0) {
            //this.loadCom()
            if (closeModal) {
              this.$set(this, 'showModal', false)
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../assets/less/general.less";

  .com-dashboard {
    overflow: auto;
    padding-left: 10px;
    padding-right: 10px;
    min-height: 200px;
    .normale {
      .tipologia {
        .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
        text-align: left;
        line-height: 30px;
        height: 30px;
        letter-spacing: 2px;
      }
      .tipologia-icon {
        height: 60px;
        margin-bottom: 20px;
        .fa-icon {
          float: left;
          margin-top: 5px;
          width: 20%;
        }
        .titolo {
          height: 60px;
          float: right;
          width: 80%;
          .riga1 {
            width: 100%;
            .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
            text-align: right;
            line-height: 40px;
            height: 40px;
            letter-spacing: 2px;
            float: right;
            padding-top: 10px;
          }
          .riga2 {
            width: 100%;
            .set-font(@color: #485eb5, @size: 10px, @family: 'os-semibold');
            text-align: right;
            line-height: 20px;
            height: 20px;
            float: right;
          }
        }
      }
      .comunicazione {
        height: 70px;
        border-bottom: 1px solid #e7e7e7;
        margin-bottom: 10px;
        &.last {
          border-bottom: none;
        }
        .com-titolo {
          .titolo {
            .set-font(@color: #B03488; @size: 14px; @family: 'os-semibold');
            text-align: left;
            line-height: 30px;
            height: 30px;
            float: left;
            width: 70%;
            letter-spacing: 1px;
          }
          .el-button {
            float: right;
            background-color: @oroRiva !important;
            border: 1px solid @oroRiva !important;
          }
        }
        .com-testo {
          .set-font(@color: @textTable, @size: 12px, @family: 'os-lightitalic');
          text-align: left;
          line-height: 20px;
          height: 20px;
          float: left;
          width: 100%;
        }
        .com-data {
          .set-font(@color: @greenRiva, @size: 12px, @family: 'os-lightitalic');
          text-align: left;
          line-height: 20px;
          height: 20px;
          float: left;
          width: 100%;
        }
      }
    }
    .compressa {
      .tipologia {
        .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
        text-align: left;
        line-height: 30px;
        height: 30px;
        letter-spacing: 2px;
      }
      .tipologia-icon {
        height: 60px;
        margin-bottom: 20px;
        .fa-icon {
          float: left;
          margin-top: 5px;
          width: 20%;
        }
        .titolo {
          height: 60px;
          float: right;
          width: 80%;
          .riga1 {
            width: 100%;
            .set-font(@color: @greenRiva, @size: 14px, @family: 'os-semibold');
            text-align: right;
            line-height: 40px;
            height: 40px;
            letter-spacing: 2px;
            float: right;
            padding-top: 10px;
          }
          .riga2 {
            width: 100%;
            .set-font(@color: #485eb5, @size: 10px, @family: 'os-semibold');
            text-align: right;
            line-height: 20px;
            height: 20px;
            float: right;
          }
        }
      }
      .comunicazione {
        height: 45px;
        border-bottom: 1px solid #e7e7e7;
        margin-bottom: 10px;
        &.last {
          border-bottom: none;
        }
        .com-titolo {
          width: 70%;
          float: left;
          .titolo {
            .set-font(@color: @greenRiva, @size: 14px);
            text-align: left;
            line-height: 20px;
            height: 20px;
            float: left;
            width: 100%;
          }
          .data {
            .set-font(@color: @textTable, @size: 12px, @family: 'os-lightitalic');
            text-align: left;
            line-height: 15px;
            height: 25px;
            float: left;
            width: 100%;
          }
        }
        .com-action {
          width: 30%;
          float: right;
          .el-button {
            margin-top: 5px;
            width: 80px !important;
            //background-color: @oroRiva !important;
            //border: 1px solid @oroRiva !important;
            float: right;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/HomePage/Comunicazione.vue